import React from 'react';
import logo from '../assets/ResumeGlobeLogo.svg';
import './MaintenancePage.css';

const MaintenancePage = ({ message }) => {
  return (
    <div className="maintenance-page">
      <div className="maintenance-content">
        {/* Logo */}
        <div className="maintenance-logo">
          <img src={logo} alt="ResumeGlobe" />
        </div>

        {/* Gear icon */}
        <div className="maintenance-icon">
          <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="#64748b" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06A1.65 1.65 0 0 0 9 4.68 1.65 1.65 0 0 0 10 3.17V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
          </svg>
        </div>

        <h1 className="maintenance-title">Under Maintenance</h1>

        <p className="maintenance-message">
          {message || 'Server is currently under maintenance. We apologize for the inconvenience. Please stay tuned for further updates.'}
        </p>

        <div className="maintenance-divider"></div>

        <p className="maintenance-subtext">
          We're working to improve your experience. Please check back shortly.
        </p>
      </div>
    </div>
  );
};

export default MaintenancePage;
